export default __webpack_public_path__ + "static/Sfax-Media-credit-Dennis-Jarvis-c1b94832cdc9e24b96c5466aed842224.jpg";